"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Source_1 = require("./Source");
/**
 * Extended by {@link Source} objects which needs {@link Credentials} to authenticate
 */
var AuthenticatableSource = /** @class */ (function (_super) {
    __extends(AuthenticatableSource, _super);
    function AuthenticatableSource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Automatically adding that here to simplify operations down the road
         */
        _this.isAuthenticatable = true;
        /**
         * The actual credentials
         *
         * @remarks
         * By default, even if the {@link Source} is Authenticatable, there can be no credentials
         */
        _this.credentials = null;
        return _this;
    }
    return AuthenticatableSource;
}(Source_1.Source));
exports.AuthenticatableSource = AuthenticatableSource;
//# sourceMappingURL=AuthenticatableSource.js.map